function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CyprusFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4345",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4345)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4345",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4345)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.4255 6.5694C18.4255 6.5694 14.4639 8.75792 13.9652 8.8964C13.4666 9.03484 13.7992 9.11802 12.9402 9.06266C12.0815 9.00725 10.3917 9.37163 10.0039 9.1223C9.61598 8.87281 9.47745 8.42965 9.44994 9.17778C9.42215 9.92557 10.0319 10.5627 9.25591 10.6182C8.48051 10.6735 8.39721 9.9531 7.87108 10.3966C7.34466 10.8397 6.90136 11.8371 6.56879 11.5877C6.23641 11.3382 5.76561 10.6735 5.90413 11.3107C6.04237 11.9478 6.45797 13.5525 7.78776 13.5802C9.11766 13.6081 9.39444 13.137 9.44994 13.5249C9.50516 13.9126 10.0871 13.968 10.2254 13.4694C10.3642 12.9707 11.4999 14.0255 12.1093 13.4991C12.7187 12.9729 13.2173 12.5295 13.4114 12.2248C13.6052 11.9201 14.2701 11.9756 14.9073 11.9756C15.5444 11.9756 16.486 12.2525 15.9874 11.6432C15.4891 11.0335 14.6301 10.7567 15.129 10.1472C15.6274 9.53777 19.8593 7.51133 20.0533 7.28965C20.2471 7.06805 19.0071 6.23701 18.4255 6.5694Z",
        fill: "#F57A01"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.4255 6.5694C18.4255 6.5694 14.4639 8.75792 13.9652 8.8964C13.4666 9.03484 13.7992 9.11802 12.9402 9.06266C12.0815 9.00725 10.3917 9.37163 10.0039 9.1223C9.61598 8.87281 9.47745 8.42965 9.44994 9.17778C9.42215 9.92557 10.0319 10.5627 9.25591 10.6182C8.48051 10.6735 8.39721 9.9531 7.87108 10.3966C7.34466 10.8397 6.90136 11.8371 6.56879 11.5877C6.23641 11.3382 5.76561 10.6735 5.90413 11.3107C6.04237 11.9478 6.45797 13.5525 7.78776 13.5802C9.11766 13.6081 9.39444 13.137 9.44994 13.5249C9.50516 13.9126 10.0871 13.968 10.2254 13.4694C10.3642 12.9707 11.4999 14.0255 12.1093 13.4991C12.7187 12.9729 13.2173 12.5295 13.4114 12.2248C13.6052 11.9201 14.2701 11.9756 14.9073 11.9756C15.5444 11.9756 16.486 12.2525 15.9874 11.6432C15.4891 11.0335 14.6301 10.7567 15.129 10.1472C15.6274 9.53777 19.8593 7.51133 20.0533 7.28965C20.2471 7.06805 19.0071 6.23701 18.4255 6.5694Z",
        fill: "url(#paint0_linear_621_4345)"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.18407 15.0781C10.1507 15.0781 11.8407 17.2667 11.8407 17.2667C11.8691 17.2951 11.8954 17.3227 11.9196 17.3496C11.9438 17.3227 11.97 17.2951 11.9985 17.2667C11.9985 17.2667 13.9696 15.0781 15.9364 15.0781C17.9032 15.0781 14.5192 18.264 12.3308 18.264C12.3308 18.264 12.1059 18.2435 11.9196 18.1498C11.7333 18.2435 11.5083 18.264 11.5083 18.264C9.31982 18.264 6.21703 15.0781 8.18407 15.0781Z",
        fill: "#006B49"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.18407 15.0781C10.1507 15.0781 11.8407 17.2667 11.8407 17.2667C11.8691 17.2951 11.8954 17.3227 11.9196 17.3496C11.9438 17.3227 11.97 17.2951 11.9985 17.2667C11.9985 17.2667 13.9696 15.0781 15.9364 15.0781C17.9032 15.0781 14.5192 18.264 12.3308 18.264C12.3308 18.264 12.1059 18.2435 11.9196 18.1498C11.7333 18.2435 11.5083 18.264 11.5083 18.264C9.31982 18.264 6.21703 15.0781 8.18407 15.0781Z",
        fill: "url(#paint1_linear_621_4345)"
      })]
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_621_4345",
      x1: "22.5",
      y1: "16.5",
      x2: "22.5",
      y2: "4.5",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#EA5113"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#FC9B58"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_621_4345",
      x1: "16.5282",
      y1: "18.264",
      x2: "16.5282",
      y2: "15.0781",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#008057"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#00B77C"
      })]
    })]
  })]
}));
//# sourceMappingURL=Cyprus.js.map